import { PricingTiers } from '@/components/pricing-tiers';
import { PricingTiersBlockProps } from '@/types/block-types';

const PricingTiersBlock = ({ id, ...props }: PricingTiersBlockProps) => {
  return <PricingTiers id={id} {...props} />;
};

export { PricingTiersBlock };
